import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';

import eyeIcon from "../../../../common/images/eyeIcon.png";
import editIcon from "../../../../common/images/editIcon.png";
import trashIcon from "../../../../common/images/trashIcon.png";

const getPetrolBunkColums = (handleDelete, handleViewDetail, handleEditBunk) =>  {
  return [
    {
      key: 'name',
      label: 'AGENCY DETAILS',
      render: (row) => {
        const district = row.district ?? '';
        const state = row.state ?? '';
        return (
          <>
            <span className='agency-name-txt'>{row.name}</span>
            <div className='agency-address1-txt'>{district}, {state}</div>
          </>
        );
      },
    },
    {
      key: 'bunkIncharges',
      label: 'INCHARGE DETAILS',
      render: (row) => {
        const firstName = row.bunkIncharges[0]?.firstName ?? '';
        const lastName = row.bunkIncharges[0]?.lastName ?? '';
        const phone = row.bunkIncharges[0]?.phone ?? '';
        return (
          <>
            <span className='bunk-incharge-name'>{firstName} {lastName}</span>
            <div className='bunk-incharge-phone'>{phone}</div>
          </>
        );
      },
    },
    {
      key: 'cameraInCount',
      label: 'NO. OF IN CAMERAS',
      render: (row) => row.cameraInCount || '',
    },
    {
      key: 'cameraOutCount',
      label: 'NO. OF OUT CAMERAS',
      render: (row) => row.cameraOutCount || '',
    },
    {
      key: 'isActive',
      label: 'BUNK STATUS',
      render: (row) => {
        return (row.isActive==true) ? <span className='status-active-cls'>ACTIVE</span> : <span className='status-inactive-cls'>INACTIVE</span>;
      },
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className='action-td-coverdiv'>
          <span
            onClick={() => handleViewDetail(row)}
            title="View Details"
            role="button"
            className="text-secondary me-2"
            style={{ cursor: 'pointer' }}
          >
            <img src={eyeIcon} className='action-icons eye-icon' alt='eyeIcon' />
          </span>
          <span
            onClick={() => handleEditBunk(row)}
            title="Edit"
            role="button"
            className="me-2 text-secondary"
            style={{ cursor: 'pointer' }}
          >
            <img src={editIcon} className='action-icons action-mrg-both edit-icon' alt='editIcon' />
          </span>
          <span
            onClick={() => handleDelete(row.id)}
            title="Delete"
            role="button"
            className="text-danger"
            style={{ cursor: 'pointer' }}
          >
            <img src={trashIcon} className='action-icons trash-icon' alt='trashIcon' />
          </span>
        </div>
      ),
    },
  ];
}

export default getPetrolBunkColums;